export { createFilterOptions } from "@mui/material/Autocomplete"
import { useCallback, useMemo } from "react"

import {
  allPass,
  always,
  append,
  complement,
  has,
  ifElse,
  map,
  none,
  objOf,
  partialRight,
  pipe,
  prop,
  when,
} from "ramda"
import { isNotNil } from "ramda-extension/es"

const wrapOption = objOf("option")

const isInputOption = allPass([has("inputValue"), complement(has("option"))])

export const unwrapLabel = ifElse(
  isInputOption,
  prop("inputLabel"),
  when(has("option"), prop("option")),
)

export const unwrapOption = ifElse(
  isInputOption,
  prop("inputValue"),
  when(has("option"), prop("option")),
)

export const useComboboxLabelCreation = ({
  options,
  optionLabel: handleOptionLabel,
  onChange: handleChange,
  filterOptions: handleFilter,
  eqOptionLabel = always(false),
}) => {
  const wrapped = useMemo(() => map(wrapOption, options), [options])
  const optionLabel = useCallback(
    (option) => handleOptionLabel(unwrapLabel(option)),
    [handleOptionLabel],
  )
  const onChange = useCallback(
    (event, value) => {
      if (value instanceof Array) {
        handleChange(event, map(unwrapOption, value))
      } else {
        handleChange(event, unwrapOption(value))
      }
    },
    [handleChange],
  )
  const filterOptions = useCallback(
    (options, params) =>
      when(
        allPass([
          always(params.inputValue !== ""),
          none(
            pipe(prop("option"), when(isNotNil, partialRight(eqOptionLabel, [params.inputValue]))),
          ),
        ]),
        pipe(
          when(always(handleFilter), partialRight(handleFilter, [params])),
          append({
            inputValue: params.inputValue,
            inputLabel: `(new) "${params.inputValue}"`,
          }),
        ),
      )(options),
    [handleFilter],
  )
  return {
    options: wrapped,
    optionLabel,
    onChange,
    filterOptions,
  }
}
